import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConstructionBrick = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "construction-brick" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .75,
			y1: 18.75,
			x2: 8.25,
			y2: 18.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 20.25,
			y1: 18.75,
			x2: 23.25,
			y2: 18.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .75,
			y1: 14.25,
			x2: 8.25,
			y2: 14.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .75,
			y1: 9.75,
			x2: 11.25,
			y2: 9.75
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12.75,5.25H2.25a1.5,1.5,0,0,0-1.5,1.5v15a1.5,1.5,0,0,0,1.5,1.5h21"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 18.718,
			y: .407,
			width: 3,
			height: 6.75,
			rx: 1,
			ry: 1,
			transform: "translate(31.841 20.752) rotate(-135)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M17.3,13.062l2.652-2.651a1.5,1.5,0,0,0,0-2.122L17.832,6.168"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M11.58,17.81a.75.75,0,0,0,.974.974l6.981-2.775a1.5,1.5,0,0,0,.418-2.416l-3.182-3.182a1.5,1.5,0,0,0-2.416.418Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.25,
			y1: 14.25,
			x2: 5.25,
			y2: 18.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 6.75,
			y1: 9.75,
			x2: 6.75,
			y2: 14.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 9.75,
			y1: 5.25,
			x2: 9.75,
			y2: 9.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 6.75,
			y1: 18.75,
			x2: 6.75,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 17.25,
			y1: 20.25,
			x2: 17.25,
			y2: 23.25
		})
	]
});
export default SvgConstructionBrick;
